import React, { Component } from "react";
import BackgroundSlider from 'react-background-slider'

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Devsolucoes from "../../components/dev-solucoes";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";

import image1 from '../../assets/img/solucoes/img-solucoes_gestao-de-jornada.jpg'


class Atendimentocheckup extends Component {
  
    render() {
      return (
          <React.Fragment>
                <Headbody></Headbody>
                <Menu></Menu>
                
                <section class="header-interno padrao">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 col-lg-8">
                                <h2>Itech<span class="azul">Flow</span></h2>
                                <h3>Solução para atendimento Check-Up</h3>
                                <span class="saude">Saúde</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="conteudo-interno">
                    <div class="container">
                        <div class="row d-lg-flex align-items-lg-center">
                            <div class="col-12 col-lg-6">
                                {/* <div id="galeria" class="owl-carousel">
                                    <img src={"../assets/img/solucoes/img-solucoes_gestao-de-jornada.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                                </div> */}
                                <div style={{width: '520px', height: '320px'}}>
                                    {/* <BackgroundSlider
                                        images={[image1]}
                                        duration={10}
                                        transition={0.1}
                                    /> */}
                                    <img src={image1} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                                </div>
                            </div>

                            <div class="col-12 col-lg-6">
                                <h3>Descrição:</h3>
                                {/* <p>Nossa solução para gestão Check-up foi desenvolvida com o objetivo de assegurar a “MELHOR EXPERIÊNCIA NA JORNADA DO PACIENTE” com o controle e orientação de pacientes dentro de um fluxo contínuo de exames. Através da rastreabilidade dentro de uma unidade diagnóstica, pode-se obter diversas informações que facilitam a gestão dos ambientes (Salas de consultas e exames) bem como dar agilidade ao atendimento e interações preventivas com o paciente, proporcionando um atendimento realmente diferenciado e um nível superior de gestão com resultados surpreendentes.</p> */}
                                    <p>Nossa solução para gestão de Check-up foi desenvolvida com o objetivo de assegurar o controle e orientação de pacientes dentro de um fluxo contínuo de exames. Através da rastreabilidade dentro de uma unidade diagnóstica, pode-se obter diversas informações que facilitam a gestão do ambiente (salas de consultas e exames) bem como dar agilidade ao atendimento, medir os tempos em cada etapa do processo, tempo gasto em espera e diversas análises como, quantidades de exames realizados, ociosidade de salas, previsão de demanda, dentre outros.</p>
                            </div>
                            </div>

                        <div class="row">

                            <div class="col-12 mt-5">
                                <h3>Aplicação:</h3>
                                <p>Hospitais, e clínicas diagnósticas de check-up</p> 
                                
                                <h3>Principais funcionalidades e benefícios:</h3>
                            </div>


                            <div class="col-12 col-md-6">
                                <ul>
                                    <li>Melhor experiencia na jornada do paciente;</li>
                                    <li>Agilidade em todo o processo de  atendimento</li>
                                    <li>Paciente com sensação de não estar esquecido</li>
                                    <li>Paciente acompanha o status de atendimento pelo celular.</li>
                                    <li>Rastreabilidade do paciente em todo o fluxo de atendimento;</li>
                                    <li>Redução do tempo de espera;</li>
                                    <li>Melhor gestão do fluxo de pacientes e consequente aumento de capacidade operacional;</li>
                                    <li>Sistema intuitivo e fácil de operar</li>
                                </ul>
                            </div>

                            <div class="col-12 col-md-6">
                                <ul>
                                    <li>Dashboard de salas de exames disponíveis em tempo real</li>
                                    <li>Dashboard  de exames realizados e a realizar por pacientes</li>
                                    <li>Visualização das informações de forma simples e intuitiva.</li>
                                    <li>Alertas visuais de tempo médio de atendimento</li>
                                    <li>Alertas visuais de tempo de espera acima do determinado.</li>
                                    <li>Baixo custo de operacionalização;</li>
                                    <li>Geração automática de relatórios e indicadores operacionais/Gerenciais</li>
                                    <li>SW desenvolvido Web-based (Não requer APP)</li>
                                </ul>

                                <br></br>
                            </div>
                            <div class="col-12 text-center" >
                                <a href={"../pdf/catalogo-checkup.pdf"} class="btn-itm" target="_blank">Baixar Catálogo</a>
                                <br></br><br></br>
                            </div>
                            
                        </div>
                        
                    </div>
                </section>
                <Devsolucoes></Devsolucoes>
                <Footer></Footer>
                <Endbody></Endbody>
          </React.Fragment>
        
      );
    }
  }

export default Atendimentocheckup;

